import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';
  const navBg = scrolled
    ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
    : isHome
      ? 'bg-transparent'
      : 'bg-background-50/95 backdrop-blur-md shadow-sm';

  const textColor = scrolled || !isHome ? 'text-foreground-950' : 'text-white';
  const logoColor = scrolled || !isHome ? 'text-primary-600' : 'text-white';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${navBg}`}
      role="navigation"
      aria-label="主导航"
    >
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="flex items-center justify-between h-16 md:h-16">
          <Link
            to="/"
            className={`flex items-center gap-2 text-xl md:text-2xl font-bold font-heading transition-colors ${logoColor}`}
          >
            <span className="w-8 h-8 flex items-center justify-center">
              <i className="ri-plant-line" />
            </span>
            黄瓜传媒
          </Link>

          {/* Desktop nav */}
          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-3 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/'
                  ? 'text-primary-600 bg-primary-50/60'
                  : `${textColor} hover:text-primary-600 hover:bg-primary-50/40`
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`px-3 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'text-primary-600 bg-primary-50/60'
                    : `${textColor} hover:text-primary-600 hover:bg-primary-50/40`
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-3 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'text-primary-600 bg-primary-50/60'
                  : `${textColor} hover:text-primary-600 hover:bg-primary-50/40`
              }`}
            >
              关于我们
            </Link>
          </div>

          {/* Mobile hamburger */}
          <button
            type="button"
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md transition-colors ${textColor}`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="切换导航菜单"
          >
            <i className={mobileOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="md:hidden bg-background-50/98 backdrop-blur-lg border-t border-background-200/70 shadow-lg">
          <div className="px-4 py-3 space-y-1">
            <Link
              to="/"
              className={`block px-3 py-2.5 rounded-md text-sm font-medium ${
                location.pathname === '/' ? 'text-primary-600 bg-primary-50' : 'text-foreground-700'
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`block px-3 py-2.5 rounded-md text-sm font-medium ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'text-primary-600 bg-primary-50'
                    : 'text-foreground-700'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`block px-3 py-2.5 rounded-md text-sm font-medium ${
                location.pathname === '/about'
                  ? 'text-primary-600 bg-primary-50'
                  : 'text-foreground-700'
              }`}
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}